import { EVENT_RESIZE_INIT , EVENT_RESIZE_END } from './events.js'

const TIMER           = 400;
let resizeTimer       = null;
let resizing          = false;

window.addEventListener( 'resize' , ( ) => {
  if ( ! resizing ) {
    resizing = true;
    window.dispatchEvent( EVENT_RESIZE_INIT );
  }
  if ( resizeTimer !== null ) clearTimeout( resizeTimer );
  resizeTimer = setTimeout( ( ) => {
    resizing = false;
    window.dispatchEvent( EVENT_RESIZE_END );
  } , TIMER );
} );
